import cn from 'classnames';
import { QRCodeSVG } from 'qrcode.react';
import { forwardRef, HTMLProps, RefObject } from 'react';
import { useLang } from '../../hooks/use-lang';
import { Loader } from '../loader/loader';
import s from './qr-code.module.css';

interface Props extends HTMLProps<HTMLDivElement> {
  data?: string;
  isLoading?: boolean;
  imageSettings?: {
    height: number;
    width: number;
    src: string;
  };
  canvasRef?: RefObject<HTMLCanvasElement>;
  bgColor?: string;
  fgColor?: string;
}

export const QrCode = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const {
    data,
    className,
    isLoading,
    imageSettings,
    canvasRef,
    children,
    bgColor,
    fgColor,
    ...other
  } = props;
  const { t } = useLang();

  return (
    <div className={cn(s.component, className)} ref={ref} {...other}>
      {isLoading && <Loader />}
      {data ? (
        <QRCodeSVG
          value={data}
          width="100%"
          height="100%"
          size={258}
          level="H"
          bgColor={bgColor}
          fgColor={fgColor}
          imageSettings={imageSettings ? { ...imageSettings, excavate: true } : undefined}
        />
      ) : (
        t('Что-то пошло не так')
      )}
      <canvas ref={canvasRef} data-testid="qr-canvas" style={{ display: 'none' }} />
      {children}
    </div>
  );
});
